function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { politicalParties } from "../../constants/api";
import useRESTData from "./useRESTData";
import classNames from "classnames";
import { arrayToDict } from "../../utils"; // Given an array of ids, retrieve the sum of previous seats

const getPreviousSeats = (ids, parties) => ids.reduce((result, id) => (parties[id] ? parties[id].seats : 0) + result, 0);

export default ((currentData, pastData, year = 2020, electionNumber = 1, type = "REGIONAL", placeId, excludes = []) => {
  const matchParties = useRESTData("".concat(politicalParties, "?year=").concat(year, "&typeElection=").concat(type, "&numElection=").concat(electionNumber, "&regionId=").concat(placeId));
  const host = window.location.hostname.replace("localhost", "antena3");
  const idsNoCount = host.indexOf("antena3") !== -1 ? excludes : [];

  if (!matchParties || !currentData || !currentData.partiesResult || !pastData || !pastData.partiesResult) {
    return null;
  }

  const partyFormats = arrayToDict(matchParties, "currentId");
  const dictPastData = arrayToDict(pastData.partiesResult);
  return currentData.partiesResult.map(party => {
    const partyFormat = partyFormats[party.id];
    const previousSeat = idsNoCount.some(id => id === party.id) ? 0 : getPreviousSeats(partyFormat ? [partyFormat.previousIds] : [party.id], dictPastData);
    const difference = party.seats - previousSeat;
    const symbolClassName = classNames(["partyEscanos", {
      less: difference < 0,
      more: difference > 0,
      equal: difference === 0
    }]);
    return _objectSpread({}, partyFormat, {}, party, {
      difference,
      symbolClassName,
      previousSeat
    });
  });
});